<template>
  <div>
    <el-container style="background-color: #00aaee; padding:20px;">
      <el-header style="height:120px;">
        <el-row type="flex" justify="center" :gutter="20" style="height:120px;">
          <el-col :span="3">
            <div id="logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Layer_1"
                data-name="Layer 1"
                viewBox="0 0 72.89 100"
                class="logo svg replaced-svg"
              >
                <path
                  class="cls-1"
                  d="M53.36,0V26.86H19.53V0H0V100H19.24l4.47-24.23h-.07L19.82,63.93h0a17.19,17.19,0,1,1,33.24,0h0L49.26,75.77h-.08L53.65,100H72.89V0Z"
                />
              </svg>
            </div>
          </el-col>
          <el-col :span="8">
            <h1 style="color:white; text-align:left;font-size:3em;">
              Historiana Admin
            </h1>
          </el-col>
        </el-row>
      </el-header>

      <el-main>
        <el-row type="flex" justify="center" :gutter="20">
          <el-col :span="11">
            <el-alert v-if="showError" type="error">
              <h2>{{ errorMsg }}</h2>
            </el-alert>
            <form @submit.prevent="doAuth">
              <el-input placeholder="Username" v-model="username" clearable />
              <el-input
                placeholder="Password"
                v-model="password"
                show-password
              />
              <p align="center">
                <el-button
                  :disabled="!(username.length && password.length)"
                  native-type="submit"
                  >Login</el-button
                >
              </p>
            </form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "login",
  methods: {
    doAuth() {
      let vm = this
      console.log("auth with: ", this.username, this.password)
      this.$API
        .post("/login", {
          login: vm.username,
          password: vm.password,
        })
        .then((response) => {
          if (response.data.isError) {
            console.log("error: ", response.data.msg)
            vm.errorMsg = response.data.msg
            vm.showError = true
          } else {
            console.log("ok; login")
            vm.$store.commit("setUser", response.data)
            vm.$localStorage.set(
              "session",
              response.data.data.session.sessionId
            )
            vm.$localStorage.set("autologin", vm.autologin)
            vm.$router.push("/")
          }
        })
    },
  },

  data() {
    return {
      username: "admin@historiana.eu",
      password: "T0pS3cret",
      showError: false,
    }
  },
}
</script>

<style>
#logo {
  margin-right: 8px;
  padding-left: 0.98684rem;
  max-width: 100px;
  height: 100px;
  overflow: hidden;
}

.logo.svg {
  height: 100px;
  margin: 0px;
  padding: 0px;
}
.logo.svg path {
  fill: white;
  color: white;
}
.logo.svg:hover path {
  fill: #f5f5f5;
  color: #f5f5f5;
  transition-duration: 500ms;
  transition-timing-function: linear;
  transition-duration: 0.5s;
  transition-timing-function: all;
  transition-delay: 0s;
}

#logo_footer {
  width: 220px;
  fill: #fefefe;
  color: #fefefe;
}
#logo_footer.logo.svg {
  max-height: 40px;
}
</style>
